<template>
    <v-dialog v-model="showRenovationModal" persistent max-width="400">
        <v-card height="170" class="d-flex flex-column">
            <v-card-title class="text-h5 justify-center">
                Renovar manualmente
            </v-card-title>
            <v-card-text class="justify-center">
                ¿Estás seguro de que quieres renovar manualmente?</v-card-text>
            <v-card-actions class="justify-center">
                <v-btn color="primary" text @click="showRenovationModal = false">
                    Cancelar
                </v-btn>
                <v-btn color="primary" @click="renovarManualmente()" :disabled="loading" :loading="loading">
                    Confirmar
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {

    name: "RenovacionManualDialog",
    data() {
        return {
            showRenovationModal: false,
            loading: false,
            pendingAction: null
        }
    },

    methods: {
        open(action) {
            this.pendingAction = action;
            this.showRenovationModal = true;
        },

        renovarManualmente() {
            this.loading = true;

            if (this.pendingAction) {
                this.pendingAction();
            }

            this.showRenovationModal = false;
            this.loading = false;
        }
    }
}
</script>